<template>
  <div
    class="alert alert-warning bg-danger text-white"
    role="alert"
    v-if="authenticationStore.me.email_consent == 0"
  >
    <div class="container-fluid text-center">
      <p v-t="'message.EmailConsent.message'"></p>
      <div class="row">
        <div class="col-auto mx-auto">
          <div class="input-group input-group-sm d-inline-flex">
            <input
              type="text"
              class="form-control"
              placeholder="Email Address"
              aria-label="Recipient's email address"
              v-model="authenticationStore.me.email"
            />
            <button class="btn btn-light" type="button" @click="consent" v-t="'message.EmailConsent.consent'"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAuthenticationStore } from "@/stores/authentication";
import { FetchService } from "@/services/fetch.service";

const authenticationStore = useAuthenticationStore();

async function consent() {
  // FetchService.fetchData("/guardians/"+authenticationStore.me.uid,"put",{"consent":1,"email":authenticationStore.me.email}).then(response=>{authenticationStore.fetchProfile()});
  await FetchService.fetchData("/guardians/" + authenticationStore.me.uid, "put", {
    consent: 1,
    email: authenticationStore.me.email
  });
  await authenticationStore.fetchProfile();
}
</script>
